export class CommonUrl {
  static URL = 'https://telelock.tagcx.com/v5/';
  // static URL = 'http://192.168.0.107:3000/v5/';
}
